import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import * as Icons from "@ant-design/icons";
import userService from "../../services/userService";
import { useCommon } from "../../context/CommonContext";

const { Sider } = Layout;

const Sidebar = ({ collapsed, onCollapse }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setMenus, setPermissionsLoading } = useCommon();

  const [rawMenuItems, setRawMenuItems] = useState([]);

  const getIcon = (iconName) => {
    const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent /> : null;
  };

  const getMenuItems = async () => {
    try {
      const response = await userService.getAllMenuByRole();
      const data = response?.data?.data || [];

      const mapIcons = (items) =>
        items.map((item) => {
          const newItem = { ...item };

          if (typeof newItem.icon === "string") {
            newItem.icon = getIcon(newItem.icon);
          }

          if (Array.isArray(newItem.children)) {
            newItem.children = mapIcons(newItem.children);
          }

          return newItem;
        });

      setRawMenuItems(mapIcons(Array.isArray(data) ? data : []));
      setMenus(mapIcons(Array.isArray(data) ? data : []));
    } catch (err) {
      console.error("Error fetching menu items:", err);
      setRawMenuItems([]);
      setMenus([]);
    } finally {
      // Set loading to false after API call completes (success or error)
      setPermissionsLoading(false);
    }
  };

  useEffect(() => {
    getMenuItems();
  }, []);

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  const getSelectedKeys = () => {
    const path = location.pathname;
    const basePath = path.split("/")[1]; // e.g., /movies/add -> /movies

    const selectedKeys = [];

    for (const item of rawMenuItems) {
      const targetPath = item.key.split("/")[1];
      if (basePath === targetPath) {
        selectedKeys.push(item.key);
      }
      if (item.children) {
        for (const child of item.children) {
          const childTargetPath = child.key.split("/")[1];
          if (basePath === childTargetPath) {
            selectedKeys.push(child.key);
          }
        }
      }
    }

    return selectedKeys;
  };

  return (
    <Sider
      className=""
      theme="dark"
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={256}
      style={{
        zIndex: 10,
        position: "fixed",
        left: 0,
        top: 0,
        bottom: 0,
        height: "100vh",
        overflow: "auto",
      }}
    >
     <div
        style={{
          position: "relative",
          transition: "all 0.3s",
          overflow: "hidden",
          // A hairline under the mark: without it the logo floated in the same
          // flat navy as the menu, with nothing to separate brand from nav.
          borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
        }}
      >
        <div
          onClick={() => navigate("/dashboard")}
          style={{
            display: "flex",
            alignItems: "center",
            // Centred rather than space-between: there is only one child, so
            // space-between behaved as flex-start and pinned the mark left.
            justifyContent: "center",
            color: "#001529",
            height: "100%",
          }}
        >
          {/* Padding is symmetric — the previous pl-4 offset the mark to the
              right of centre, which no amount of justify-content can undo. */}
          <img
            src="/logo.svg"
            alt="Platinum Cineplex"
            className={`${collapsed ? "w-[52px] p-2" : "w-[75px] py-4"} `}
          />
        </div>
      </div>

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={getSelectedKeys()}
        items={rawMenuItems}
        onClick={handleMenuClick}
        style={{
          padding: "16px 0",
          textAlign: "left",
        }}
      />
    </Sider>
  );
};

export default Sidebar;
